import xhr from './axiosConfig';
import QS from 'qs'

export function get(url, type = null, config = {}) {
    return function (params = {}) {
        let newUrl = (type === 'add' ? (url + params) : url);
        return xhr.get(newUrl, params, config).then(data => {
            return data;
        }).catch(err => {
            return err
        })
    }
}

export function post(url, type = null, config) {
    return function (params = {}) {
        let newUrl = (type === 'add' ? (url + params) : url);
        return xhr.post(newUrl, params, config).then(data => {
            return data;
        }).catch(err => {
          if(config.returnReject) {
            return Promise.reject(config.returnReject)
          }
          return err
        })
    }
}

export function put(url, type = null, config) {
    return function (params = {}) {
        let newUrl = (type === 'add' ? (url + params) : url);
        if(type === 'flat') {
            for(const key in params) {
                if(params.hasOwnProperty(key)) {
                    newUrl += `/${params[key]}`
                }
            }
        }
        return xhr.put(newUrl, params, config).then(data => {
            return data;
        }).catch(err => {
            return err
        })
    }
}
